import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

import { FormPageContainer, FormPageHeader } from '@/components/PageLayout';
import { useListReturn } from '@/hooks/useListReturn';
import { ROUTES } from '@/routes/routes';

import { CreateProductForm } from './CreateProductForm';

export const CreateProductPage: React.FC = () => {
  const { goToList } = useListReturn(ROUTES.PRODUCTS);

  return (
    <FormPageContainer>
      <FormPageHeader>
        <Button type="text" icon={<ArrowLeftOutlined />} onClick={goToList} />
        <h2>Новий продукт</h2>
      </FormPageHeader>
      <CreateProductForm />
    </FormPageContainer>
  );
};
